const identityProviderNames = {
  microsoft_entra_id: 'Microsoft Entra ID',
  okta: 'Okta',
};

export { identityProviderNames };
